<template>
  <div class="unlock-login">
    <div v-if="!isPhone" class="login-container">
      <div class="login-form-container">
        <div style="width: 68%;">
          <div v-if="active === 'inputEmail'" class="text-login color-main-linear-blue">
            {{ reset ? 'Request Password Reset' : 'Forgot your password?' }}
          </div>
          <div v-else-if="active === 'checkEmail'" class="text-login color-main-linear-blue">
            Check Your Email
          </div>
          <div v-else-if="active === 'checkLink'" class="text-login color-main-linear-blue">
            Reset Link Expired
          </div>
          <div v-else-if="active === 'resetPassword'" class="text-login color-main-linear-blue">
            Reset Your Password
          </div>
          <div v-else-if="active === 'updatedSuccessfully'" class="text-updated-successfully">
            <div class="updated-successfully-img">
              <img src="@/assets/login/updated_successfully_ezpay.svg" alt="">
            </div>
            <div class="title">Password Updated Successfully</div>
          </div>
          <!-- 检查邮箱是否正确 -->
          <el-form v-show="active === 'inputEmail'" ref="emailForm" :model="emailForm" class="login-form" auto-complete="on" label-position="top">
            <div class="title-container">
              <!-- <h3 class="title">{{ reset ? 'Request Password Reset' : 'Forgot your password?' }}</h3> -->
              <h4 class="tips mb48">Enter your email address below, and we'll send you a link to reset your password.</h4>
            </div>

            <el-form-item prop="email" label="Email" class="login-form-item mb48" :rules="{ validator: validateEmail, trigger: 'blur' }">
              <el-input
                ref="email"
                v-model="emailForm.email"
                class="login-input"
                placeholder="Email Address"
                name="email"
                type="text"
                tabindex="1"
                auto-complete="on"
                size="default"
              />
              <h4 v-show="isNotRegistered" class="tips red">The email you entered is not registered. Please try again.</h4>
            </el-form-item>
            <el-button :loading="loading" type="info" size="default" style="width:100%;margin-bottom:30px;font-weight:600" @click.native.prevent="sendResetLink">Send Reset Link</el-button>
          </el-form>
          <!-- 检查邮箱是否收到链接 -->
          <div v-show="active === 'checkEmail'" class="login-form">
            <div class="email-img">
              <img src="@/assets/login/email_img_ezpay.svg" alt="">
            </div>
            <div class="title-container">
              <!-- <h3 class="title mt60">Check Your Email</h3> -->
              <h4 class="tips instructions-password">We've sent instructions to reset your password.</h4>
            </div>
            <h4 v-if="!exceedance" class="tips">If you don't receive an email within 5 minutes, click below to resend.</h4>
            <h4 v-if="!exceedance" class="tips mt60">Didn't receive an email?
              <span v-if="!isResend" @click="resendEmail">Resend</span>
              <span v-else class="is-resend">Resend in {{ countdownResult }}s</span>
            </h4>
            <h4 v-if="exceedance" class="tips red2">You've reached the resend limit. Please try again in 24 hours.</h4>
            <h4 v-if="exceedance" class="tips">For immediate assistance, contact our customer service.</h4>

          </div>
          <!-- 链接失效 -->
          <div v-show="active === 'checkLink'" class="login-form">
            <div class="link-img">
              <img src="@/assets/login/link_img_ezpay.svg" alt="">
            </div>
            <div class="title-container mt60">
              <!-- <h3 class="title">Reset Link Expired</h3> -->
              <h4 class="tips mb48">The password reset link you used has expired. Please request a new link to reset your password.</h4>
            </div>

            <el-button :loading="loading" type="info" size="default" style="width:100%;margin-bottom:30px;font-weight:600" @click="requestNewLink">Request New Link</el-button>
          </div>
          <!-- 重置密码 -->
          <el-form v-show="active === 'resetPassword'" ref="resetForm" :model="resetForm" class="login-form" auto-complete="on" label-position="top">
            <div class="title-container">
              <!-- <h3 class="title">Reset Your Password</h3> -->
              <h4 class="tips mb48">Please enter your new password.</h4>
            </div>

            <el-form-item prop="new_password" label="New Password" class="login-form-item form-item-password" :rules="{ validator: checkPasswordLength, trigger: ['blur','change'] }">
              <el-input
                :key="passwordType"
                ref="password"
                v-model="resetForm.new_password"
                class="login-input"
                :type="passwordType?'text':'password'"
                placeholder="New Password"
                name="password"
                tabindex="2"
                auto-complete="on"
                size="default"
                @input="changePassword"
              />
              <span class="show-pwd" @click="showPwd('passwordType','password')">
                <svg-icon :icon-class="!passwordType ? 'eye' : 'eye-open'" />
              </span>
            </el-form-item>

            <el-form-item prop="confirm_password" label="Confirm Password" class="login-form-item" :rules="{ validator: validateConfirmPassword, trigger: ['blur','change'] }">
              <el-input
                :key="passwordType"
                ref="confirmPassword"
                v-model="resetForm.confirm_password"
                class="login-input"
                :type="confirmPasswordType?'text':'password'"
                placeholder="Confirm Password"
                name="confirmPassword"
                tabindex="2"
                auto-complete="on"
                size="default"
                @keyup.enter.native="handleResetPassword"
              />
              <span class="show-pwd" @click="showPwd('confirmPasswordType','confirmPassword')">
                <svg-icon :icon-class="!confirmPasswordType ? 'eye' : 'eye-open'" />
              </span>
            </el-form-item>

            <el-button :loading="loading" type="info" size="default" style="width:100%;margin-bottom:30px;font-weight:600" @click.native.prevent="handleResetPassword">Save New Password</el-button>
          </el-form>
          <!-- 更新成功 -->
          <div v-show="active === 'updatedSuccessfully'" class="login-form">
            <!-- <div class="updated-successfully-img">
              <img src="@/assets/login/updated_successfully_ezpay.svg" alt="">
            </div> -->
            <div class="title-container">
              <!-- <h3 class="title">Password Updated Successfully</h3> -->
              <h4 class="tips mb48">Your password has been reset. You can now log in with your new password.</h4>
            </div>
            <el-button :loading="loading" type="info" size="default" style="width:100%;margin-bottom:30px;font-weight:600" @click="goLogin">Go to Login</el-button>
          </div>

          <div>
            <img class="login-bottom-logo" :src="$store.getters.isAruxpay ? require('@/assets/logo/aruxpay_logo.png') : require('@/assets/logo/ezpay_logo.svg')">
            <div class="text-all-right">©️ {{ new Date().getFullYear() }} {{ $store.getters.isAruxpay ? 'Aruxpay' : 'Ezpay' }} Information Solutions Corp, All Rights Reserved</div>
          </div>
        </div>
      </div>
      <div class="login-img">
        <img width="100%" :src="$store.getters.isAruxpay ? require('@/assets/logo/aruxpay_logo_big.svg') : require('@/assets/logo/logo_big.svg')">
      </div>

    </div>
    <div v-if="isPhone" class="xs-login-container">
      <div class="xs-login-container-content">
        <div>
          <div v-if="active === 'inputEmail'" class="text-login color-main-linear-blue">
            {{ reset ? 'Request Password Reset' : 'Forgot your password?' }}
          </div>
          <div v-else-if="active === 'checkEmail'" class="text-login color-main-linear-blue">
            Check Your Email
          </div>
          <div v-else-if="active === 'checkLink'" class="text-login color-main-linear-blue">
            Reset Link Expired
          </div>
          <div v-else-if="active === 'resetPassword'" class="text-login color-main-linear-blue">
            Reset Your Password
          </div>
          <div v-else-if="active === 'updatedSuccessfully'" class="text-updated-successfully">
            <div class="updated-successfully-img">
              <img src="@/assets/login/updated_successfully_ezpay.svg" alt="">
            </div>
            <div class="title">Password Updated Successfully</div>
          </div>
          <div>
            <img class="login-img" width="60%" :src="$store.getters.isAruxpay ? require('@/assets/logo/aruxpay_logo_big.svg') : require('@/assets/logo/logo_big.svg')">
          </div>
          <!-- 检查邮箱是否正确 -->
          <el-form v-show="active === 'inputEmail'" ref="emailForm" :model="emailForm" class="xs-login-form" auto-complete="on" label-position="top">
            <div class="title-container">
              <!-- <h3 class="title">{{ reset ? 'Request Password Reset' : 'Forgot your password?' }}</h3> -->
              <h4 class="tips mb48">Enter your email address below, and we'll send you a link to reset your password.</h4>
            </div>

            <el-form-item prop="email" label="Email" class="login-form-item mb48" :rules="{ validator: validateEmail, trigger: 'blur' }">
              <el-input
                ref="email"
                v-model="emailForm.email"
                class="login-input"
                placeholder="Email Address"
                name="email"
                type="text"
                tabindex="1"
                auto-complete="on"
                size="default"
              />
              <h4 v-show="isNotRegistered" class="tips red">The email you entered is not registered. Please try again.</h4>
            </el-form-item>
            <el-button :loading="loading" type="info" size="default" style="width:100%;margin-bottom:30px;font-weight:600" @click.native.prevent="sendResetLink">Send Reset Link</el-button>
          </el-form>
          <!-- 检查邮箱是否收到链接 -->
          <div v-show="active === 'checkEmail'" class="xs-login-form">
            <div class="email-img">
              <img src="@/assets/login/email_img_ezpay.svg" alt="">
            </div>
            <div class="title-container">
              <!-- <h3 class="title mt60">Check Your Email</h3> -->
              <h4 class="tips instructions-password">We've sent instructions to reset your password.</h4>
            </div>
            <h4 v-if="!exceedance" class="tips">If you don't receive an email within 5 minutes, click below to resend.</h4>
            <h4 v-if="!exceedance" class="tips mt60">Didn't receive an email?
              <span v-if="!isResend" @click="resendEmail">Resend</span>
              <span v-else class="is-resend">Resend in {{ countdownResult }}s</span>
            </h4>
            <h4 v-if="exceedance" class="tips red2">You've reached the resend limit. Please try again in 24 hours.</h4>
            <h4 v-if="exceedance" class="tips">For immediate assistance, contact our customer service.</h4>

          </div>
          <!-- 链接失效 -->
          <div v-show="active === 'checkLink'" class="xs-login-form">
            <div class="link-img">
              <img src="@/assets/login/link_img_ezpay.svg" alt="">
            </div>
            <div class="title-container mt60">
              <!-- <h3 class="title">Reset Link Expired</h3> -->
              <h4 class="tips mb48">The password reset link you used has expired. Please request a new link to reset your password.</h4>
            </div>

            <el-button :loading="loading" type="info" size="default" style="width:100%;margin-bottom:30px;font-weight:600" @click="requestNewLink">Request New Link</el-button>
          </div>
          <!-- 重置密码 -->
          <el-form v-show="active === 'resetPassword'" ref="resetForm" :model="resetForm" class="xs-login-form" auto-complete="on" label-position="top">
            <div class="title-container">
              <!-- <h3 class="title">Reset Your Password</h3> -->
              <h4 class="tips mb48">Please enter your new password.</h4>
            </div>

            <el-form-item prop="new_password" label="New Password" class="login-form-item form-item-password" :rules="{ validator: checkPasswordLength, trigger: ['blur','change'] }">
              <el-input
                :key="passwordType"
                ref="password"
                v-model="resetForm.new_password"
                class="login-input"
                :type="passwordType?'text':'password'"
                placeholder="New Password"
                name="password"
                tabindex="2"
                auto-complete="on"
                size="default"
                @input="changePassword"
              />
              <span class="show-pwd" @click="showPwd('passwordType','password')">
                <svg-icon :icon-class="!passwordType ? 'eye' : 'eye-open'" />
              </span>
            </el-form-item>

            <el-form-item prop="confirm_password" label="Confirm Password" class="login-form-item" :rules="{ validator: validateConfirmPassword, trigger: ['blur','change'] }">
              <el-input
                :key="passwordType"
                ref="confirmPassword"
                v-model="resetForm.confirm_password"
                class="login-input"
                :type="confirmPasswordType?'text':'password'"
                placeholder="Confirm Password"
                name="confirmPassword"
                tabindex="2"
                auto-complete="on"
                size="default"
                @keyup.enter.native="handleResetPassword"
              />
              <span class="show-pwd" @click="showPwd('confirmPasswordType','confirmPassword')">
                <svg-icon :icon-class="!confirmPasswordType ? 'eye' : 'eye-open'" />
              </span>
            </el-form-item>

            <el-button :loading="loading" type="info" size="default" style="width:100%;margin-bottom:30px;font-weight:600" @click.native.prevent="handleResetPassword">Save New Password</el-button>
          </el-form>
          <!-- 更新成功 -->
          <div v-show="active === 'updatedSuccessfully'" class="xs-login-form">
            <div class="title-container">
              <!-- <h3 class="title">Password Updated Successfully</h3> -->
              <h4 class="tips mb48">Your password has been reset. You can now log in with your new password.</h4>
            </div>
            <el-button :loading="loading" type="info" size="default" style="width:100%;margin-bottom:30px;font-weight:600" @click="goLogin">Go to Login</el-button>
          </div>

          <div class="mt-48" style="text-align: center;">
            <img class="login-bottom-logo" :src="$store.getters.isAruxpay ? require('@/assets/logo/aruxpay_logo.png') : require('@/assets/logo/ezpay_logo.svg')">
            <div class="text-all-right">©️ {{ new Date().getFullYear() }} {{ $store.getters.isAruxpay ? 'Aruxpay' : 'Ezpay' }} Information Solutions Corp, All Rights Reserved</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendResetPwdEmail, resetPwd, isExpired } from '@/api/user'
import { cryptoJSAesEncrypt } from '@/utils/encrypt'

export default {
  name: 'ForgotPassword',
  components: { },
  data() {
    this.validateEmail = (rule, value, callback) => {
      if (!value || value.length <= 0) {
        return callback(new Error('Please enter the email'))
      }
      return callback()
    }
    this.checkPasswordLength = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Passwords cannot be empty'))
      }
      if (value && (value.length < 8 || value.length > 15)) {
        return callback(new Error('Passwords must between 8 ~ 15 character'))
      }
      const regex = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@%*&_])[A-Za-z\\d@%*&_]{8,15}$')
      if (!regex.test(value)) {
        return callback(new Error('New Password must be between 8 and 15 characters. Must contain and only contain the following: uppercase and lowercase letters, alphabets, and special characters (limited to @%*&_).'))
      }

      return callback()
    }
    this.validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Confirm Password cannot be empty'))
      }
      if (!value || this.resetForm.confirm_password !== this.resetForm.new_password) {
        return callback(new Error('The passwords entered twice are inconsistent'))
      }
      return callback()
    }
    return {
      active: 'inputEmail', // inputEmail  resetPassword updatedSuccessfully
      isResend: false,
      isNotRegistered: false,
      exceedance: false,
      reset: false,
      resetForm: {
        new_password: '',
        confirm_password: ''
      },
      emailForm: {
        email: ''
      },
      loading: false,
      passwordType: false,
      confirmPasswordType: false,
      isPhone: false,
      countdownTimer: null,
      countdownResult: '',
      token: ''
    }
  },
  created() {
    this.changePage()
    this.checkIsExpired()
  },
  mounted() {
    window.onresize = () => {
      this.changePage()
    }
  },
  beforeDestroy() {
    window.onresize = null
    this.initCountdown()
  },
  methods: {
    checkIsExpired() {
      if (this.$route.query.token) {
        isExpired({ token: this.$route.query.token }).then(res => {
          if (res.code === 10000 && res.data === true) {
            this.token = this.$route.query.token
            this.active = 'resetPassword'
          } else {
            this.active = 'checkLink'
            this.reset = true
          }
        })
      }
    },
    changePage() {
      const screenWidth = document.documentElement.clientWidth
      if (screenWidth <= 768) {
        this.isPhone = true
      } else {
        this.isPhone = false
      }
    },
    showPwd(type, ref) {
      this[type] = !this[type]
      this.$nextTick(() => {
        this.$refs[ref].focus()
      })
    },
    sendResetLink(type) {
      if (this.loading) return
      this.$refs.emailForm.validate((valid) => {
        if (valid) {
          const params = {
            username: cryptoJSAesEncrypt(this.emailForm.email)
          }
          if (this.$store.getters.isEz || this.$store.getters.isAruxpay) {
            params.mch_counterparty = cryptoJSAesEncrypt('unlock')
          } else {
            params.mch_counterparty = cryptoJSAesEncrypt('paycools')
          }
          this.loading = true
          sendResetPwdEmail(params).then(res => {
            if (res.code === 10000) {
              if (type === 'resend') {
                this.initCountdown()
              }
              const failCode = res.data?.fail_code
              switch (failCode) {
                // 未注册的邮箱
                case 20013:
                  this.isNotRegistered = true
                  break
                  // 超过次数限制
                case 20014:
                  this.active = 'checkEmail'
                  this.exceedance = true
                  break
                  // 成功发送邮件
                default:
                  this.active = 'checkEmail'
                  break
              }
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    resendEmail() {
      this.sendResetLink('resend')
    },
    clearTimer(timer) {
      if (timer !== null) {
        clearInterval(timer)
        timer = null
      }
    },
    initCountdown() {
      this.isResend = true
      this.countdownResult = 120
      this.countdownTimer = setInterval(() => {
        if (this.countdownResult > 1) {
          this.countdownResult--
        } else {
          this.clearTimer(this.countdownTimer)
          this.isResend = false
        }
      }, 1000)
    },
    requestNewLink() {
      this.active = 'inputEmail'
    },
    handleResetPassword() {
      this.$refs.resetForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const params = {
            new_password: cryptoJSAesEncrypt(this.resetForm.new_password),
            confirm_password: cryptoJSAesEncrypt(this.resetForm.confirm_password),
            token: this.token
          }
          if (this.$store.getters.isEz || this.$store.getters.isAruxpay) {
            params.mch_counterparty = cryptoJSAesEncrypt('unlock')
          } else {
            params.mch_counterparty = cryptoJSAesEncrypt('paycools')
          }
          resetPwd(params).then(res => {
            if (res.code === 10000 && res.data?.fail_code !== 20015) {
              this.active = 'updatedSuccessfully'
            } else {
              this.active = 'checkLink'
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    goLogin() {
      this.resetForm = {}
      this.emailForm = {}
      this.$router.push('/login')
      this.active = 'inputEmail'
    },
    changePassword() {
      if (this.resetForm.confirm_password) {
        this.$refs.resetForm.validate()
      }
    }
  }
}
</script>
<style>
.unlock-login  input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #fff inset !important;
   -webkit-text-fill-color: #4B5567 !important;
}
.unlock-login .login-input .el-input__inner{
  height: 42px;
  border: 1px solid #D2D8E3;
  font-size: 16px;
  border-radius: 8px;
}
.unlock-login .login-form-item .el-form-item__label{
  font-size: 18px;
}
.unlock-login .xs-login-container .google-login-verify{
  /* width: 250px; */
  overflow-y: hidden;
  overflow-x: auto;
}

@media screen and (max-width: 1441px) {
  .unlock-login .login-form-item .el-form-item__label{
    font-size: 16px;
  }
  .unlock-login .login-input .el-input__inner{
    height: 38px;
    font-size: 13px;
  }
}
</style>

<style lang="scss" scoped>
.tips{
  color: rgba(54, 60, 74, 0.50);
  font-size: 16px;
  margin-top: 0;
  margin-bottom: 20px;
  font-weight: 500;
  &.red{
    color: #991B1B;
    margin-bottom: 0;
  }
  &.red2{
    color: #991B1B;
    margin: 48px 0;
  }
  span{
    color: #0058CF;
    font-weight: 700;
    cursor: pointer;
    &.is-resend{
      color: rgba(0, 88, 207, 0.50);
      cursor: not-allowed;
    }
  }
}
.mt60{
  margin-top: 60px;
}
.mb48{
  margin-bottom: 48px;
}
.unlock-login{
  height: 100vh;
}
.instructions-password{
  color: #363C4A;
  margin-top: 16px;
}
.text-updated-successfully{
  position: relative;
  z-index: 5;
  text-align: center;
  .title{
    color: #1D3A71;
    font-size: 28px;
    font-weight: 700;
    margin: 32px 0 66px 0;
  }
}
.login-container {
  height: 100vh;
  width: 100%;
  background: #EDF2F9;
  overflow: hidden;
  display: flex;
  .login-img{
    // padding-top: 60px;
    width: 45%;
    min-height: 650px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
     .login-img-content{
       width: 80%;
     }
  }
  .login-form-container{
    position: relative;
    height: 100vh;
    width: 55%;
    display: flex;
    justify-content:center;
    align-items: center;
  }

  .login-form {
    padding: 24px;
    max-width: 550px;
    border-radius: 12px;
    background: #FFFFFF;
    box-shadow: 0px 155px 43px 0px rgba(0, 0, 0, 0.00), 0px 99px 40px 0px rgba(0, 0, 0, 0.02), 0px 56px 33px 0px rgba(0, 0, 0, 0.06), 0px 25px 25px 0px rgba(0, 0, 0, 0.10), 0px 6px 14px 0px rgba(0, 0, 0, 0.12);
    margin: 66px 0 71px 0;
    .updated-successfully-img{
      display: flex;
      justify-content: center;
    }
  }
  .show-pwd{
    position: absolute;
    right: 13px;
    top: 3px;
    cursor: pointer;
  }
  .text-login{
    font-size: 64px;
    font-weight: 600;
    margin-bottom: 96px;
    line-height: normal;
    width: max-content;
  }
  .login-bottom-logo{
    margin-top: 80px;
    height: 32px;
  }
  .text-all-right{
    margin-top: 24px;
    color: #5E6E82;
    font-size: 12px;
  }
}

@media screen and (max-width: 1441px) {
  .login-container{
    .login-form-container{
      // align-items: flex-start;
    }
    .text-login{
      font-size: 32px;
      margin-bottom: 25px;
      margin-top: 10px;
    }
    .login-bottom-logo{
      margin-top: 25px;
      height: 32px;
    }
    .text-all-right{
      margin-top: 10px;
      color: #5E6E82;
      font-size: 12px;
    }
  }
}
@media screen and (max-height: 780px){
  .login-container{
    .text-login{
      margin-bottom: 55px;
    }
    .login-bottom-logo{
      margin-top: 0px;
    }
  }
}
</style>

<style lang="scss" scoped>
.form-item-password{
  margin-bottom: 30px;
}
.xs-login-container {
  height: 100vh;
  // width: 100%;
  padding:  0 30px;
  background: #EDF2F9;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  .login-img{
    position: absolute;
    top: 0;
    right: 0;
  }
  .xs-login-form {
    position: relative;
    z-index: 2;
    padding: 24px;
    max-width: 550px;
    border-radius: 12px;
    background: #FFFFFF;
    box-shadow: 0px 155px 43px 0px rgba(0, 0, 0, 0.00), 0px 99px 40px 0px rgba(0, 0, 0, 0.02), 0px 56px 33px 0px rgba(0, 0, 0, 0.06), 0px 25px 25px 0px rgba(0, 0, 0, 0.10), 0px 6px 14px 0px rgba(0, 0, 0, 0.12);
    .updated-successfully-img{
      display: flex;
      justify-content: center;
    }
  }
  .show-pwd{
    position: absolute;
    right: 13px;
    top: 3px;
    cursor: pointer;
  }
  .text-login{
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 49px;
    line-height: normal;
  }
  .login-bottom-logo{
    height: 32px;
  }
  .text-all-right{
    margin-top: 24px;
    color: #5E6E82;
    font-size: 12px;
  }
}

</style>
